import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { FormatService } from '@services/format.service';
import { Cursor } from '@classes/simulation/cursor';
import { IndiceModeType } from '@enums/indice-mode-type.enum';

@Component({
    selector: 'app-hapy-cursor',
    templateUrl: './hapy-cursor.component.html',
    styleUrls: ['./hapy-cursor.component.scss']
})
export class HapyCursorComponent implements OnChanges {
    @Input() cursor: Cursor;
    @Input() value = 0;
    @Input() mode: IndiceModeType;
    @Input() label: string;
    @Input() isDisabled: boolean;
    @Input() isNotEditable: boolean;
    @Input() allowInput: boolean;

    @Output() valueChanged = new EventEmitter<number>();
    @Output() buttonClicked = new EventEmitter<string>();

    indiceMode = IndiceModeType;
    cursorForm: FormGroup;
    localCursor: Cursor;

    constructor(
        private formatSrv: FormatService,
        private fb: FormBuilder
    ) { }

    ngOnChanges() {
        this.localCursor = {...this.cursor};

        if(this.mode === IndiceModeType.amount) {
            this.localCursor.step = 1000;
            this.localCursor.maxValue = null;
            this.localCursor.minValue = null;
        }

        if(this.allowInput) {
            this.initForm();
        }
    }

    formatValue(value: number, showSign: boolean): string {
        const sign = (value >= 0 && showSign) ? '+' : '';
        const stringValue: string = this.formatSrv.formatCursor(value, this.mode);

        return sign + stringValue;
    }

    onButtonClick(operator): void {
        if(operator === '+') {
            if(this.localCursor.maxValue == null
                || (this.value + this.localCursor.offset) < this.localCursor.maxValue) {
                this.value += this.localCursor.step;
            }
        } else {
            if(this.localCursor.minValue == null
                || (this.value + this.localCursor.offset) > this.localCursor.minValue) {
                this.value -= this.localCursor.step;
            }
        }

        this.buttonClicked.emit(operator);
        this.valueChanged.emit(this.value);
    }

    onShowValue(): void {
        this.cursorForm.controls.amount.setValue(this.value);
    }

    onEmitValue(): void {
        this.value = this.cursorForm.value.amount;
        this.cursorForm.controls.amount.setValue(this.convertAmount(this.value));
        this.valueChanged.emit(this.value);
    }

    private initForm(): void {
        this.cursorForm = this.fb.group({});

        switch(this.mode) {
            case IndiceModeType.percent:
            case IndiceModeType.ac:
                const indiceValue = this.convertIndice(this.value, 100, 2);
                this.cursorForm.addControl('indice', this.fb.control(indiceValue));
                this.observeIndiceChanges();
                break;
            case IndiceModeType.amount:
            default:
                this.cursorForm.addControl('amount', this.fb.control(this.convertAmount(this.value)));
                // this.observeAmountChanges();
        }
    }

    private observeIndiceChanges(): void {
        this.cursorForm.controls.indice.valueChanges
        .subscribe(indice => {
            if(indice != null && !isNaN(indice)) {
                const tempIndice = this.convertIndice(indice, 0.01, 4);
                this.valueChanged.emit(tempIndice);
            }
        });
    }

    private observeAmountChanges(): void {
        this.cursorForm.controls.amount.valueChanges
        .subscribe((amountS: string) => {
            const amount = this.formatSrv.stringToFloat(amountS);
            this.valueChanged.emit(amount);
        });
    }

    private convertIndice(value: number, convert: number, precision: number): number {
        return (this.mode === IndiceModeType.percent) ?  this.formatSrv.precision(value * convert, precision) : value;
    }

    private convertAmount(value: number): string {
        return this.formatSrv.formatAmount(value, 'rounded', 1, false);
    }
}
